export default __webpack_public_path__ + "reverse_roll.png";